import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
//import 'element-ui/lib/theme-default/index.css'
//import './assets/theme/theme-green/index.css'
//import './assets/theme/theme-darkblue/index.css'

import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import './icons'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
//import Mock from './mock'
//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'



Vue.use(ElementUI)

Vue.use(VueRouter)
Vue.use(Vuex)
NProgress.configure({ easing:'ease', speed:500,showSpinner: false });

const router = new VueRouter({

  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start();

  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path.indexOf('login')<0) {
    next({ path: '/login' })
  } else {
    next()
  }
})

router.afterEach(transition => {
NProgress.done();
});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js